import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const BlockAlignmentCenterIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "BlockAlignmentCenter",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M3.15 17.76v-3.48a4.1 4.1 0 0 1 4.1-4.1h17.51a4.1 4.1 0 0 1 4.1 4.1v3.48a4.1 4.1 0 0 1-4.1 4.1H7.25a4.1 4.1 0 0 1-4.1-4.1M16.05 30h-.09c-.62 0-1.12-.5-1.12-1.12v-3.6c0-.62.5-1.12 1.12-1.12h.09c.62 0 1.12.5 1.12 1.12v3.6c0 .62-.5 1.12-1.12 1.12M15.9 2h.21c.59 0 1.06.48 1.06 1.06v3.72c0 .59-.48 1.06-1.06 1.06h-.21c-.59 0-1.06-.48-1.06-1.06V3.06c0-.59.48-1.06 1.06-1.06"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M15.57 29.29c-.63 0-1.14-.51-1.14-1.14V3a1.14 1.14 0 1 1 2.28 0v25.15c0 .63-.51 1.14-1.14 1.14M11 21.29H5.29c-1.89 0-3.43-1.54-3.43-3.43v-4.57c0-1.89 1.54-3.43 3.43-3.43H11a1.14 1.14 0 1 1 0 2.28H5.29c-.63 0-1.14.51-1.14 1.14v4.57c0 .63.51 1.14 1.14 1.14H11a1.14 1.14 0 1 1 0 2.28ZM25.86 21.29h-5.71a1.14 1.14 0 1 1 0-2.28h5.71c.63 0 1.14-.51 1.14-1.14V13.3c0-.63-.51-1.14-1.14-1.14h-5.71a1.14 1.14 0 1 1 0-2.28h5.71c1.89 0 3.43 1.54 3.43 3.43v4.57c0 1.89-1.54 3.43-3.43 3.43Z"
      })
    })
  }));
};
BlockAlignmentCenterIcon.displayName = 'BlockAlignmentCenterIcon';